module.exports = __webpack_public_path__ + "img/1761987655044-bhdwh0TE.88c238c4.png";